import { Dialog, Disclosure, Transition } from "@headlessui/react";
import {
  BriefcaseIcon,
  ChatIcon,
  ChevronDownIcon,
  ClipboardCheckIcon,
  CogIcon,
  HomeIcon,
  OfficeBuildingIcon,
  TemplateIcon,
  TicketIcon,
  UserGroupIcon,
  XIcon,
} from "@heroicons/react/outline";
import { BookmarkIcon, MailIcon } from "@heroicons/react/solid";
import React, { Fragment, useState } from "react";
import { Link } from "react-router-dom";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

const navigation = [
  { name: "Overview", href: "/", icon: HomeIcon, current: false },

  { name: "User Section", href: "#", icon: HomeIcon, current: false },
  {
    name: "Order Section",
    href: "#",
    icon: ClipboardCheckIcon,
    current: false,
  },
];

const siteSettings = [
  {
    name: "Banner & Footer",
    href: "/banner-footer",
    icon: ClipboardCheckIcon,
    current: false,
  },
  {
    name: "Flagship Stores",
    href: "/flagship-store",
    icon: OfficeBuildingIcon,
    current: false,
  },
  {
    name: "Coupons",
    href: "/coupons",
    icon: ClipboardCheckIcon,
    current: false,
  },
  {
    name: "Brand",
    href: "/brands",
    icon: ClipboardCheckIcon,
    current: false,
  },
  {
    name: "Attribute",
    href: "/attribute",
    icon: OfficeBuildingIcon,
    current: false,
  },
];

const vendorSettings = [
  {
    name: "Overview",
    href: "/vendor",
    icon: ClipboardCheckIcon,
    current: false,
  },
  // {
  //   name: "Approvals",
  //   href: "/approvals",
  //   icon: TemplateIcon,
  //   current: false,
  // },
  {
    name: "Vendor List",
    href: "/vendor-list",
    icon: ClipboardCheckIcon,
    current: false,
  },
  // {
  //   name: "Notify All",
  //   href: "/notify",
  //   icon: OfficeBuildingIcon,
  //   current: false,
  // },
  // {
  //   name: "My Dashboard",
  //   href: "/my-dashboard",
  //   icon: ClipboardCheckIcon,
  //   current: false,
  // },
];

const userSettings = [
  {
    name: "Users Overview",
    href: "/users",
    icon: ClipboardCheckIcon,
    current: false,
  },
  // {
  //   name: "Subscription Info",
  //   href: "/subscription",
  //   icon: TemplateIcon,
  //   current: false,
  // },
  {
    name: "User List",
    href: "/users-list",
    icon: ClipboardCheckIcon,
    current: false,
  },
  // {
  //   name: "Notify All Users",
  //   href: "/users-notify",
  //   icon: OfficeBuildingIcon,
  //   current: false,
  // },
];

const productSettings = [
  {
    name: "Overview",
    href: "/products",
    icon: ClipboardCheckIcon,
    current: false,
  },
  {
    name: "Product List",
    href: "/product-list",
    icon: TemplateIcon,
    current: false,
  },
  // {
  // 	name: "2 Star Product",
  // 	href: "/star-products",
  // 	icon: ClipboardCheckIcon,
  // 	current: false,
  // },
];

const pickupStore = [
  {
    name: "Overview",
    href: "/pickup-store",
    icon: ClipboardCheckIcon,
    current: false,
  },
  {
    name: "All Pickup",
    href: "/all-pickup",
    icon: TemplateIcon,
    current: false,
  },
];
export default function Sidebar() {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <>
      <Transition.Root show={sidebarOpen} as={Fragment}>
        <Dialog
          as="div"
          className="relative z-40 md:hidden"
          onClose={setSidebarOpen}
        >
          <Transition.Child
            as={Fragment}
            enter="transition-opacity ease-linear duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="transition-opacity ease-linear duration-300"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-gray-600 bg-opacity-75" />
          </Transition.Child>

          <div className="fixed inset-0 flex z-40">
            <Transition.Child
              as={Fragment}
              enter="transition ease-in-out duration-300 transform"
              enterFrom="-translate-x-full"
              enterTo="translate-x-0"
              leave="transition ease-in-out duration-300 transform"
              leaveFrom="translate-x-0"
              leaveTo="-translate-x-full"
            >
              <Dialog.Panel className="relative flex-1 flex flex-col max-w-xs w-full pt-5 pb-4 bg-white">
                <Transition.Child
                  as={Fragment}
                  enter="ease-in-out duration-300"
                  enterFrom="opacity-0"
                  enterTo="opacity-100"
                  leave="ease-in-out duration-300"
                  leaveFrom="opacity-100"
                  leaveTo="opacity-0"
                >
                  <div className="absolute top-0 right-0 -mr-12 pt-2">
                    <button
                      type="button"
                      className="ml-1 flex items-center justify-center h-10 w-10 rounded-full focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white"
                      onClick={() => setSidebarOpen(false)}
                    >
                      <span className="sr-only">Close sidebar</span>
                      <XIcon
                        className="h-6 w-6 text-white"
                        aria-hidden="true"
                      />
                    </button>
                  </div>
                </Transition.Child>

                <div className="flex-shrink-0 flex items-center px-4">
                  <img
                    className="h-8 w-auto"
                    src="https://tailwindui.com/img/logos/workflow-logo-indigo-600-mark-gray-800-text.svg"
                    alt="Workflow"
                  />
                </div>

                <div className="mt-5 flex-1 h-0 overflow-y-auto">
                  <nav className="px-2 space-y-1">
                    <Link
                      to="/"
                      className="text-gray-600 hover:bg-gray-50 hover:text-gray-900 group flex items-center px-2 py-2 text-sm font-medium rounded-md"
                    >
                      <HomeIcon
                        className="text-gray-400 group-hover:text-gray-500 
                      mr-3 flex-shrink-0 h-5 w-5"
                        aria-hidden="true"
                      />
                      Overview
                    </Link>
                  </nav>
                </div>
              </Dialog.Panel>
            </Transition.Child>
            <div className="flex-shrink-0 w-14" aria-hidden="true">
              {/* Dummy element to force sidebar to shrink to fit close icon */}
            </div>
          </div>
        </Dialog>
      </Transition.Root>

      <div className="hidden md:flex md:w-64 md:flex-col md:fixed md:inset-y-0">
        {/* Sidebar component, swap this element with another sidebar if you like */}
        <div className="flex flex-col flex-grow border-r border-gray-200 pt-5 bg-white overflow-y-auto">
          <Link to="/" className="flex  items-center flex-shrink-0 px-4">
            <img
              className="h-12 w-auto object-contain"
              src="/images/logo.png"
              alt="Byduy Vendor "
            />
          </Link>

          <div className="mt-5 flex-grow flex flex-col">
            <nav className="flex-1 px-2 pb-4 space-y-1">
              <Link
                to="/"
                className="text-gray-600 hover:bg-gray-50 hover:text-gray-900 group flex items-center px-2 py-2 text-sm font-medium rounded-md"
              >
                <HomeIcon
                  className="text-gray-400 group-hover:text-gray-500 
                      mr-3 flex-shrink-0 h-5 w-5"
                  aria-hidden="true"
                />
                Overview
              </Link>

              <Disclosure
                as="div"
                className=" px-2 py-2  rounded-md text-gray-600 hover:bg-gray-50 hover:text-gray-900"
              >
                {({ open }) => (
                  <>
                    <dt className="">
                      <Disclosure.Button className=" w-full flex justify-between items-start">
                        <div className="flex items-center text-sm font-medium">
                          <CogIcon className="mr-3 flex-shrink-0 h-5 w-5 text-gray-400 group-hover:text-gray-500" />
                          Site Settings
                        </div>
                        <span className="ml-6 h-5 flex items-center">
                          <ChevronDownIcon
                            className={classNames(
                              open ? "-rotate-180" : "rotate-0",
                              "h-6 w-6 transform text-gray-500"
                            )}
                            aria-hidden="true"
                          />
                        </span>
                      </Disclosure.Button>
                    </dt>
                    <Disclosure.Panel as="dd" className=" pl-6">
                      {siteSettings.map((item) => (
                        <Link
                          key={item.name}
                          to={item.href}
                          className="text-gray-500 flex items-center px-2 py-2 text-sm font-medium "
                        >
                          <item.icon
                            className={classNames(
                              item.current
                                ? "text-gray-500"
                                : "text-gray-400 group-hover:text-gray-500",
                              "mr-3 flex-shrink-0 h-5 w-5"
                            )}
                            aria-hidden="true"
                          />
                          {item.name}
                        </Link>
                      ))}
                    </Disclosure.Panel>
                  </>
                )}
              </Disclosure>

              <Link
                to="/add-management"
                className="text-gray-600 hover:bg-gray-50 hover:text-gray-900
                  group flex items-center px-2 py-2 text-sm font-medium rounded-md"
              >
                <BookmarkIcon
                  className="text-gray-400 group-hover:text-gray-500 
                      mr-3 flex-shrink-0 h-5 w-5"
                  aria-hidden="true"
                />
                Ads Management
              </Link>

              <Link
                to="/category"
                className="text-gray-600 hover:bg-gray-50 hover:text-gray-900 group flex items-center px-2 py-2 text-sm font-medium rounded-md"
              >
                <ClipboardCheckIcon
                  className="text-gray-400 group-hover:text-gray-500 
                      mr-3 flex-shrink-0 h-5 w-5"
                  aria-hidden="true"
                />
                Categories
              </Link>

              <Disclosure
                as="div"
                className=" px-2 py-2  rounded-md text-gray-600 hover:bg-gray-50 hover:text-gray-900"
              >
                {({ open }) => (
                  <>
                    <dt className="">
                      <Disclosure.Button className=" w-full flex justify-between items-start">
                        <div className="flex items-center text-sm font-medium">
                          <BriefcaseIcon className="mr-3 flex-shrink-0 h-5 w-5 text-gray-400 group-hover:text-gray-500" />
                          Product Section
                        </div>
                        <span className="ml-6 h-5 flex items-center">
                          <ChevronDownIcon
                            className={classNames(
                              open ? "-rotate-180" : "rotate-0",
                              "h-6 w-6 transform text-gray-500"
                            )}
                            aria-hidden="true"
                          />
                        </span>
                      </Disclosure.Button>
                    </dt>
                    <Disclosure.Panel as="dd" className=" pl-6">
                      {productSettings.map((item) => (
                        <Link
                          key={item.name}
                          to={item.href}
                          className="text-gray-500 flex items-center px-2 py-2 text-sm font-medium "
                        >
                          <item.icon
                            className={classNames(
                              item.current
                                ? "text-gray-500"
                                : "text-gray-400 group-hover:text-gray-500",
                              "mr-3 flex-shrink-0 h-5 w-5"
                            )}
                            aria-hidden="true"
                          />
                          {item.name}
                        </Link>
                      ))}
                    </Disclosure.Panel>
                  </>
                )}
              </Disclosure>

              <Link
                to="/orders"
                className="text-gray-600 hover:bg-gray-50 hover:text-gray-900 group flex items-center px-2 py-2 text-sm font-medium rounded-md"
              >
                <TicketIcon
                  className="text-gray-400 group-hover:text-gray-500 
                      mr-3 flex-shrink-0 h-5 w-5"
                  aria-hidden="true"
                />
                Order Section
              </Link>

              <Disclosure
                as="div"
                className=" px-2 py-2  rounded-md text-gray-600 hover:bg-gray-50 hover:text-gray-900"
              >
                {({ open }) => (
                  <>
                    <dt className="">
                      <Disclosure.Button className=" w-full flex justify-between items-start">
                        <div className="flex items-center text-sm font-medium">
                          <CogIcon className="mr-3 flex-shrink-0 h-5 w-5 text-gray-400 group-hover:text-gray-500" />
                          Vendor Section
                        </div>
                        <span className="ml-6 h-5 flex items-center">
                          <ChevronDownIcon
                            className={classNames(
                              open ? "-rotate-180" : "rotate-0",
                              "h-6 w-6 transform text-gray-500"
                            )}
                            aria-hidden="true"
                          />
                        </span>
                      </Disclosure.Button>
                    </dt>
                    <Disclosure.Panel as="dd" className=" pl-6">
                      {vendorSettings.map((item) => (
                        <Link
                          key={item.name}
                          to={item.href}
                          className="text-gray-500 flex items-center px-2 py-2 text-sm font-medium "
                        >
                          <item.icon
                            className={classNames(
                              item.current
                                ? "text-gray-500"
                                : "text-gray-400 group-hover:text-gray-500",
                              "mr-3 flex-shrink-0 h-5 w-5"
                            )}
                            aria-hidden="true"
                          />
                          {item.name}
                        </Link>
                      ))}
                    </Disclosure.Panel>
                  </>
                )}
              </Disclosure>

              <Disclosure
                as="div"
                className=" px-2 py-2  rounded-md text-gray-600 hover:bg-gray-50 hover:text-gray-900"
              >
                {({ open }) => (
                  <>
                    <dt className="">
                      <Disclosure.Button className=" w-full flex justify-between items-start">
                        <div className="flex items-center text-sm font-medium">
                          <UserGroupIcon className="mr-3 flex-shrink-0 h-5 w-5 text-gray-400 group-hover:text-gray-500" />
                          Users Section
                        </div>
                        <span className="ml-6 h-5 flex items-center">
                          <ChevronDownIcon
                            className={classNames(
                              open ? "-rotate-180" : "rotate-0",
                              "h-6 w-6 transform text-gray-500"
                            )}
                            aria-hidden="true"
                          />
                        </span>
                      </Disclosure.Button>
                    </dt>
                    <Disclosure.Panel as="dd" className=" pl-6">
                      {userSettings.map((item) => (
                        <Link
                          key={item.name}
                          to={item.href}
                          className="text-gray-500 flex items-center px-2 py-2 text-sm font-medium "
                        >
                          <item.icon
                            className={classNames(
                              item.current
                                ? "text-gray-500"
                                : "text-gray-400 group-hover:text-gray-500",
                              "mr-3 flex-shrink-0 h-5 w-5"
                            )}
                            aria-hidden="true"
                          />
                          {item.name}
                        </Link>
                      ))}
                    </Disclosure.Panel>
                  </>
                )}
              </Disclosure>

              <Link
                to="/delivery-man"
                className="text-gray-600 hover:bg-gray-50 hover:text-gray-900 group flex items-center px-2 py-2 text-sm font-medium rounded-md"
              >
                <MailIcon
                  className="text-gray-400 group-hover:text-gray-500 
                      mr-3 flex-shrink-0 h-5 w-5"
                  aria-hidden="true"
                />
                Delivery Man
              </Link>

              <Disclosure
                as="div"
                className=" px-2 py-2  rounded-md text-gray-600 hover:bg-gray-50 hover:text-gray-900"
              >
                {({ open }) => (
                  <>
                    <dt className="">
                      <Disclosure.Button className=" w-full flex justify-between items-start">
                        <div className="flex items-center text-sm font-medium">
                          <OfficeBuildingIcon className="mr-3 flex-shrink-0 h-5 w-5 text-gray-400 group-hover:text-gray-500" />
                          Pickup Store
                        </div>
                        <span className="ml-6 h-5 flex items-center">
                          <ChevronDownIcon
                            className={classNames(
                              open ? "-rotate-180" : "rotate-0",
                              "h-6 w-6 transform text-gray-500"
                            )}
                            aria-hidden="true"
                          />
                        </span>
                      </Disclosure.Button>
                    </dt>
                    <Disclosure.Panel as="dd" className=" pl-6">
                      {pickupStore.map((item) => (
                        <Link
                          key={item.name}
                          to={item.href}
                          className="text-gray-500 flex items-center px-2 py-2 text-sm font-medium "
                        >
                          <item.icon
                            className={classNames(
                              item.current
                                ? "text-gray-500"
                                : "text-gray-400 group-hover:text-gray-500",
                              "mr-3 flex-shrink-0 h-5 w-5"
                            )}
                            aria-hidden="true"
                          />
                          {item.name}
                        </Link>
                      ))}
                    </Disclosure.Panel>
                  </>
                )}
              </Disclosure>

              <Link
                to="/chats"
                className="text-gray-600 hover:bg-gray-50 hover:text-gray-900 group flex items-center px-2 py-2 text-sm font-medium rounded-md"
              >
                <ChatIcon
                  className="text-gray-400 group-hover:text-gray-500 
                      mr-3 flex-shrink-0 h-5 w-5"
                  aria-hidden="true"
                />
                Chat
              </Link>
            </nav>
          </div>
        </div>
      </div>
    </>
  );
}
